import type { AuthState } from '@newfront-insurance/ms-graph-auth';
import { createContext, useContext } from 'react';

/**
 * MS Graph authentication context.
 * Provides MS Graph auth state and methods to all Nova components.
 * Returns null when feature flag is OFF (100% backward compatible).
 */
export interface MSGraphAuthContext {
  authState: AuthState;
  login: () => Promise<AuthState>;
  logout: () => Promise<void>;
  graphClient: unknown | null;
  shouldTriggerOfficeLogin: () => boolean;
  isOfficeLoginInProgress: () => boolean;
  getAccessToken: () => Promise<string | null> | null;
}
const MSGraphContext = createContext<MSGraphAuthContext | null>(null);
export const MSGraphProvider = MSGraphContext.Provider;

/**
 * Hook to access MS Graph authentication.
 * Returns null when feature flag is OFF (backward compatible).
 */
export function useMSGraphAuth() {
  return useContext(MSGraphContext);
}